import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Device } from '@capacitor/device';

@Component({
  standalone: false,
  selector: 'pptl-full-layout',
  templateUrl: 'full-layout.component.html',
  styleUrls: ['full-layout.component.scss'],
})
export class FullLayoutComponent implements OnInit {
  constructor(private renderer: Renderer2, private el: ElementRef) {}

  async ngOnInit() {
    const info = await Device.getInfo();
    if (info?.platform === 'android') {
      this.renderer.addClass(this.el.nativeElement, 'is-android');
    }
  }
}
